import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ExpandedRowTable } from '@/components/ui/tables/ExpandedRowTable';
import type { ExpandedRowTableColumn } from '@/components/ui/tables/ExpandedRowTable';
import type { LocationEmployeeItem } from '@/api/domains/checkInLocation';


interface AssignedTabExpandedRowProps {
  employees: LocationEmployeeItem[];
}

export const AssignedTabExpandedRow: React.FC<AssignedTabExpandedRowProps> = ({ employees }) => {
  const { t: translate } = useTranslation('checkInLocation');

  const columns: ExpandedRowTableColumn[] = useMemo(() => [
    { key: 'rut', label: translate('assigned.expandedColumns.rut') },
    { key: 'name', label: translate('assigned.expandedColumns.name') },
  ], [translate]);

  const rows = useMemo(
    () => employees.map((employee) => ({
      rut: employee.employeeTaxIdentificationNumber,
      name: employee.employeeName,
    })),
    [employees],
  );

  return (
    <div data-testid={employees.length === 0 ? 'assigned-tab-expand-empty' : 'assigned-tab-expand-content'}>
      <ExpandedRowTable
        columns={columns}
        rows={rows}
        emptyMessage={translate('assigned.expandedEmpty')}
        columnWidths={['w-1/4', 'w-3/4']}
      />
    </div>
  );
};

export default AssignedTabExpandedRow;
